module.exports = __webpack_public_path__ + "img/tdglleft.1fb85164.png";